import { Navigate } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Pages } from '../../types/pages';
import { FeatureFlags } from '../../types/featureFlags';

const ApplicationsList = () => {
  const flags = useFlags<Record<string, boolean>>();
  const isEnabled = flags[FeatureFlags.ApplicationsList] === true;

  return isEnabled ? <div>Applications List Content</div> : <Navigate replace to={Pages.Home} />;
};

export default ApplicationsList;